import { createContext, useContext } from 'react';

export interface LayoutContextValue {
  // SSE connection state
  sseConnected: boolean;
  ssePolling: boolean;
  switchToPolling: () => void;
  reconnectSSE: () => void;

  // Selected simulation (for nav display)
  selectedSimulationId: string | null;
  selectedSimulationName: string | null;
  setSelectedSimulation: (id: string | null, name: string | null) => void;

  // Results state (for nav display)
  hasResults: boolean;
  resultsCount: number;
  setResultsInfo: (hasResults: boolean, count: number) => void;

  // Simulation run state (async background run)
  // Note: runningSimulationId tracks WHICH simulation is running (null if none).
  // isSimulationRunning is derived: true only if the CURRENT simulation is running.
  // This ensures switching simulations doesn't leak running state from previous simulation.
  runningSimulationId: string | null;
  isSimulationRunning: boolean;
  simulationRunError: string | null;
  markSimulationRunStarted: (simulationId: string) => void;
  clearSimulationRun: () => void;

  // Results version - incremented when new results are available (for Results page to detect changes)
  resultsVersion: number;
}

export const LayoutContext = createContext<LayoutContextValue | null>(null);

export function useLayoutContext(): LayoutContextValue {
  const context = useContext(LayoutContext);
  if (!context) {
    throw new Error('useLayoutContext must be used within a LayoutProvider');
  }
  return context;
}
